<pt-details-layout
  [noDataMessage]="'MESSAGE.NO_ATTACHMENTS_AVAILABLE' | translate"
  [showNoData]="!attachments || attachments.length === 0"
  [title]="'LABELS.ATTACHMENTS' | translate">
  <ng-container body>
    <div *ngIf='attachments?.length > 0' class='mt-2'>
      <ng-container *ngFor='let attachment of attachments; index as i'>
        <div *ngIf='i < 3' class='mb-2'>
          <div (click)="downloadAttachment(attachment)" class='da-attachment-container px-2 py-1'>
            <pt-icon [iconType]='SVG'
                     [key]='attachment?.attachmentType?.toLowerCase() + ".svg"'
                     [size]='30'
            ></pt-icon>

            <div class='w-100 d-flex flex-row justify-content-between'>
              <div class='da-attachment'>
                <span [container]='"body"'
                      [ngbTooltip]='attachment?.name'
                >{{ attachment?.name ? attachment?.name : ('MESSAGE.ATTACHMENT_WITHOUT_NAME' | translate) }}</span>

                <span [ngbTooltip]='attachment?.checksum' class='da-checksum text-muted'
                      container='body'
                >{{ "LABELS.CHECKSUM" | translate }}: {{ attachment?.checksum }}</span>
              </div>
            </div>
          </div>
        </div>
      </ng-container>

      <div #collapse='ngbCollapse' [(ngbCollapse)]='isCollapsedOtherAttributes'>
        <ng-container *ngFor='let attachment of attachments; index as i'>
          <div *ngIf='i >= 3' class='mb-2'>
            <div (click)="downloadAttachment(attachment)" class='da-attachment-container px-2 py-1'>
              <pt-icon [iconType]='SVG'
                       [key]='attachment?.attachmentType?.toLowerCase() + ".svg"'
                       [size]='30'
              ></pt-icon>

              <div class='da-attachment'>
                <span [container]='"body"'
                      [ngbTooltip]='attachment?.name'
                >{{ attachment?.name }}</span>

                <span [ngbTooltip]='attachment?.checksum' class='da-checksum text-muted'
                      container='body'
                >{{ "LABELS.CHECKSUM" | translate }}: {{ attachment?.checksum }}</span>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
    <button (click)='collapse.toggle(isCollapsedOtherAttributes)'
            *ngIf='enableExpand'
            [attr.aria-expanded]='!isCollapsedOtherAttributes'
            aria-controls='collapseExample'
            class='btn btn-sm btn-more'
            type='button'>
      {{(isCollapsedOtherAttributes ?
      'LABELS.EXPAND' :
      'LABELS.REDUCE') | translate}}
      <label [ngClass]="{ 'flip-icon': !isCollapsedOtherAttributes}"
             class='m-0 form-label'
             ngbTooltip="{{(isCollapsedOtherAttributes ?
           'LABELS.EXPAND' :
           'LABELS.REDUCE') | translate}}">
        <pt-icon [iconType]='iconType'
                 [key]='iconArrow'
                 [size]='iconSize'>
        </pt-icon>
      </label>
    </button>
  </ng-container>
</pt-details-layout>
